module.exports = __webpack_public_path__ + "static/img/live_none.32a0b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/live_none.png
// module id = NqyM
// module chunks = 1